// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1DzR9","selects":"Documents_selects__100ff"};